module.exports = __webpack_public_path__ + "img/google-play.c3d53fcc.png";